module.exports = __webpack_public_path__ + "static/media/21ECLAC25.508cafac.jpg";